<template>
    <v-container fluid>
        <v-card
            class="mx-auto"
            max-width="375"
        >
            <v-card-title
                class="justify-center"
                :style="formStyle"
            >
                {{ outlet.name }}
            </v-card-title>
            <v-card-subtitle
                :style="formStyle"
                class="text-center"
            >
                {{ queue.name }} <span v-if="service">({{ service.name }})</span>
            </v-card-subtitle>
            <v-card-text
                class="text-center pt-3"
                style="font-size: larger"
            >
                Dear <span
                style="font-weight: bold">{{ qlistInside.name }}</span>
            </v-card-text>
            <v-card-text
                class="text-center"
                v-if="qlistInside.status === 3 || qlistInside.status === 4 || qlistInside.status === 6"
            >
                {{ statusText }}
            </v-card-text>
            <v-card-text
                class="text-center"
                v-if="qlistInside.status === 2 || qlistInside.status === 5"
            >
                There are {{ qlength }} people ahead.
            </v-card-text>
            <v-img
                :src="'/storage/ticket_template.png'"
                contain
            >
                <v-card-text
                    class="text-center"
                >
                    Your Queue Number is
                </v-card-text>
                <v-card-text
                    class="text-center"
                    style="font-size: large;padding: 5px 0 0 0"
                >
                    <span style="text-decoration: underline;font-weight: bold;font-size: xx-large">{{
                            qlistInside.queue_no
                        }}</span>
                </v-card-text>
                <v-card-text
                    class="text-center"
                    style="padding: 5px 0 0 0"
                >
                    {{ textContent }}
                </v-card-text>
                <v-card-text
                    class="text-center pa-0"
                    style="font-weight: bold;"
                >
                    {{ formattedDate }}
                </v-card-text>
            </v-img>
            <v-card-text
                class="text-center pa-0"
                style="font-weight: bold;"
                v-if="qlistInside.called_at && (qlistInside.status === 2 || qlistInside.status === 5 )"
            >
                Your Number have been called at {{ calledTime }}.
            </v-card-text>
            <v-card-text
                class="text-center pa-0"
                style="font-weight: bold;"
                v-if="qlistInside.counter && (qlistInside.status === 2 || qlistInside.status === 5 )"
            >
                Please proceed to {{ qlistInside.counter }}.
            </v-card-text>
            <v-card-actions
                class="justify-center pa-5"
            >
                <v-btn
                    rounded
                    color="primary"
                    dark
                    style="font-weight: bold"
                    @click="arrived"
                    v-if="qlistInside.status === 2 || qlistInside.status === 6"
                >Arrived
                </v-btn>

                <v-btn
                    rounded
                    color="error"
                    dark
                    style="font-weight: bold"
                    @click="dialog = true"
                    v-if="qlistInside.status === 2 || qlistInside.status === 5"
                >{{ cancelText }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-dialog
            v-model="dialog"
            max-width="375"
        >
            <v-card>
                <v-card-title>{{ outlet.name }}</v-card-title>

                <v-card-text>
                    {{ leaveSentence }}
                </v-card-text>

                <v-card-actions
                    class="justify-center"
                >
                    <v-btn
                        @click="dialog = false"
                    >
                        cancel
                    </v-btn>

                    <v-btn
                        dark
                        color="green darken-1"
                        @click="leaveQ"
                    >
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="isloading"
            max-width="375"
        >
            <v-card
                class="text-center"
            >
                <v-card-title
                    class="justify-center"
                    style="font-weight: bold;"
                >
                    Loading...
                </v-card-title>
                <v-progress-circular
                    indeterminate
                    class="mb-0"
                    :size="70"
                    :width="7"
                ></v-progress-circular>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from 'axios'
import QueueForm from './Queues/QueueForm'
import {VueTelInput} from 'vue-tel-input'
import moment from 'moment'

export default {
    name: 'live-details',
    props: ['outlet', 'queue', 'service', 'qlist'],
    components: {
        'queue-form': QueueForm
    },
    data: () => {
        return {
            estimateTime: null,
            qlength: 0,
            dialog: null,
            isloading: false,
            qlistDataByApi: null,
            autoRefreshTimer: null,
        }
    },
    computed: {
        formStyle() {
            return {
                backgroundColor: this.outlet.main_color ? this.outlet.main_color : 'black',
                color: this.outlet.main_font_color ? this.outlet.main_font_color : 'white',
            }
        },
        confirmStyle() {
            return {
                fontSize: "30px"
            }
        },
        myBackground() {
            return '/storage' + this.outlet.bg_image;
        },
        myLogo() {
            return '/storage' + this.outlet.logo;
        },
        btnColor() {
            return this.outlet.main_color ? this.outlet.main_color : 'black';
        },
        btnFontClass() {
            let c = this.outlet.main_font_color ? this.outlet.main_font_color : 'white';
            return c + '--text'
        },
        sloganStyle() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '40px',
                color: this.outlet.slogan_color ? this.outlet.slogan_color : '#000000'
            }
        },
        cancelText() {
            return this.qlistInside.type === "online" ? "Cancel Appointment" : "Leave the line"
        },
        formattedDate() {
            const d = moment(this.qlistInside.appointment_date)
            return d.format('YYYY-MM-DD HH:mm')
            // let date = new Date(this.qlistInside.appointment_date);
            // let month = (date.getMonth() + 1 < 10) ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
            // let day = (date.getDate() < 10) ? '0' + (date.getDate()) : date.getDate()
            // let hour = (date.getHours() < 10) ? '0' + (date.getHours()) : date.getHours()
            // let minute = (date.getMinutes() < 10) ? '0' + (date.getMinutes()) : date.getMinutes()
            // return date.getFullYear() + '-' + month + '-' + day + ' ' + hour + ':' + minute
        },
        textContent() {
            if (this.qlistInside.type === "online") {
                return "for appointment at"
            } else {
                return "queue from "
            }
        },
        statusText() {
            let sentence = '';
            switch (this.qlistInside.status) {
                case 3:
                    return "You have been Served. Thank you for choosing our services."
                case 4:
                    return "Your queue has been cancelled."
                case 6:
                    return "You have missed your queue."
            }
        },
        calledTime() {
            let t = new Date(this.qlistInside.called_at)

            let hours = (t.getHours() < 10) ? '0' + (t.getHours()) : t.getHours()
            let minutes = (t.getMinutes() < 10) ? '0' + (t.getMinutes()) : t.getMinutes()

            return hours + ':' + minutes
        },
        leaveSentence() {
            return this.qlistInside.type === "online" ? "Are you sure you want to cancel the appointment?" : "Are you sure you want to leave the queue?"
        },
        qlistInside() {
          return this.qlistDataByApi ? this.qlistDataByApi : this.qlist;
        }
    },
    methods: {
        leaveQ() {
            this.dialog = false;
            this.isloading = true;
            this.updateStatus(this.qlistInside, 'cancel');
        },
        arrived() {
            this.updateStatus(this.qlistInside, 'arrived');
        },
        updateStatus(qlist, status) {
            axios.post('/api/queueList/updateStatus', {
                qlist_id: qlist.id,
                status: status,
            }).then(response => {
                this.isLoading = false;
                window.location.reload()
            });
        },
        fetchQList() {
          let path = window.location.pathname;
          if (!path) {
            return;
          }

          const apiPath = path.replace('/q/','/api/qlist/')
          axios.get(apiPath).then(response => {
            this.qlistDataByApi = response.data;
            // this.estimateTime = response.data
          });
        },
        fetchEstimateTime() {
          axios.post('/api/getEstimateTime', {
            qlist_id: this.qlist.id
          }).then(response => {
            this.estimateTime = response.data
          });
        },

        fetchQueueLengthAhead() {
          axios.post('/api/getQueueLengthAhead', {
            queue_id: this.qlist.queue_id,
            qlist_id: this.qlist.id,
          }).then(response => {
            this.qlength = response.data
          });
        },

    },
    beforeMount() {
      this.fetchEstimateTime();
      this.fetchQueueLengthAhead();

      this.autoRefreshTimer = setInterval(() => {
        this.fetchQList();
        this.fetchEstimateTime();
        this.fetchQueueLengthAhead();
      }, 1 * 60 * 1000);
      console.log(this.qlist)
    },
    beforeDestroy() {
      clearInterval(this.autoRefreshTimer);
    }
}
</script>

<style>
.my-logo {
    width: 150px;
    height: 150px;
    margin-left: -50px;
    top: 80px;
    z-index: 200;
    position: absolute;
    left: 45%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/AppointmentDetails.vue